import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]




export default /*#__PURE__*/_defineComponent({
  props: {
    number: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  number: number | string;
  disabled: boolean;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "rounded-full border-3 border-opacity-30 border-white text-2xl w-key h-key flex justify-center items-center",
    disabled: props.disabled,
    role: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('numericKeyPressed', __props.number.toString())))
  }, _toDisplayString(props.number), 9, _hoisted_1))
}
}

})